module.exports = __webpack_public_path__ + "static/media/arrows.ddfd27ec.svg";